import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

export const Nav = () => (
  <motion.header
    initial={{ y: -64, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-[#060D1A]/70 backdrop-blur-xl"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
      <button
        data-testid="nav-brand-logo"
        onClick={() => scrollToSection("#hero")}
        className="font-display font-bold text-lg tracking-tight text-white"
      >
        OG<span className="hidden min-[420px]:inline text-slate-500 font-mono-label text-xs ml-2 tracking-[0.3em]">SOLUTIONS</span>
      </button>
      <div className="flex items-center gap-4">
        <a
          href="/login"
          data-testid="nav-login-link"
          className="text-sm font-medium text-slate-400 transition-colors duration-300 hover:text-white"
        >
          <span className="hidden sm:inline">Client Login</span>
          <span className="sm:hidden">Log in</span>
        </a>
        <button
          data-testid="nav-book-call-cta"
          onClick={() => scrollToSection("#contact-form")}
          className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-4 sm:px-5 py-2 text-sm font-semibold text-[#060D1A] transition-colors duration-300 hover:bg-slate-300"
        >
          <span className="hidden min-[420px]:inline">Book My Free Call</span>
          <span className="min-[420px]:hidden">Free Call</span>
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </button>
      </div>
    </div>
  </motion.header>
);
